import axios from "axios";

export default function ReceiptgroupShowService(receiptGroupId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/receipt_group/" + receiptGroupId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
